/* import __COLOCATED_TEMPLATE__ from './watch-series-video-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();